import { useState } from 'react';
import { IApplicationsForTask } from '../Job/types';
import Api from '../Job/API';

export const useApplicationsForTask = () => {
  const [applications, setApplications] = useState<IApplicationsForTask[]>([]);

  const fetchApplications = async (jobId: number) => {
    let page = 1;
    let totalPages = 9999;
    let results: IApplicationsForTask[] = [];

    while (page <= totalPages) {
      const response = await Api.getApplicationsForTask(jobId, page);
      results = [...results, ...response.data.applications];
      if (page === 1) {
        setApplications(results);
      }
      totalPages = response.totalPages;
      page += 1;
    }

    if (page > 1) {
      setApplications(results);
    }
  };

  return { applications, fetchApplications };
};
